<template>
  <div class="Aframe"> 
            
  <!--   <a-scene>

      <a-assets>
        <img id="water" :src="require('@/commons/img/water.jpg')"/>
      </a-assets> 

      <a-camera position="0 1.5 0"></a-camera>
      <a-light type="directional" intensity="1.5" position="0 1 0"></a-light>
      <a-light type="ambient" intensity="0.25"></a-light>

      <a-plane src="#water" height="100" width="100" rotation="0 0 0"></a-plane>
      
    </a-scene>
   
    <div class="Aframe__layers"> 
      AFRAME
    </div> -->

    <button @click="test">Change sphere color</button>
    <a-scene>
      <a-assets>
        <img id="water" :src="require('@/commons/img/water.jpg')"/>
      </a-assets> 
      <a-box position="-1 0.5 -3" rotation="0 45 0" color="#4CC3D9"></a-box>
      <a-sphere material-displacement position="0 1.25 -5" radius="1.25" color="blue"></a-sphere>
      <a-cylinder position="1 0.75 -3" radius="0.5" height="1.5" color="#FFC65D"></a-cylinder>
      <a-plane position="0 0 -4" rotation="-90 0 0" width="4" height="4" color="#7BC8A4"></a-plane>
      <!-- <a-sky color="#ECECEC"></a-sky> -->
      <a-plane  position="0 1 -2" src="#water" height="1" width="1" rotation="0 0 0"></a-plane>
    </a-scene>




  </div>
</template>

<script>

import gsap from "gsap"
import * as THREE from 'three'
import { Vertex, Fragment } from './shaders/Shader.js'

export default {

    name: 'Aframe',

    data: ()=>({
        welcome: false,
        animated: false,
        presentation: false,
        sequence: false,
        buttons: false,
        scan_removed: false,
        presentation_completed: false,
        use_sequence: false,
        object_is_ready: false,
        model: null,
        gbl: null
    }),


    beforeCreate() {

      // a-canvas a-grab-cursor


      console.log('xxxxx !!');

      /* global AFRAME, THREE */

      AFRAME.registerComponent('material-displacement', {
        /**
         * Creates a new THREE.ShaderMaterial using the two shaders defined
         * in vertex.glsl and fragment.glsl.
         */
        init: function () {

          console.log('init');

          this.material  = new THREE.ShaderMaterial({
            uniforms: {time: { value: 0.0 }},
            vertexShader: Vertex,
            fragmentShader: Fragment
          });
          console.log(this.material);
          this.el.addEventListener('model-loaded', () => this.update());
        },

        /**
         * Apply the material to the current entity.
         */
        update: function () {
          const mesh = this.el.getObject3D('mesh');
          if (mesh) {
            mesh.material = this.material;
          }
        },

        /**
         * On each frame, update the 'time' uniform in the shaders.
         */
        tick: function (t) {
          this.material.uniforms.time.value = t / 1000;
        }
        
      })



    },



    mounted() {
      // window.alert('material-displacement')
      // window.alert(this.glb +'.glb 2.77')
    },

    methods: {

      test() {
        const sphere = document.querySelector("a-sphere");
        const color = sphere.getAttribute("color")
        sphere.setAttribute("color", color === "blue" ? "green" : "blue")
      }


   }
    

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Aframe
  overflow hidden
  position absolute
  width 100%
  height 100%
  color white
  //background red

.red 
  color #f00
  
button 
  position fixed
  z-index 9999


</style>














